import React, { useEffect } from 'react';
import logo from '@assets/logo/kisPayment_logo(horizontal).png';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const MainLoadingForKis = () => {
  const navigation = useNavigate();
  Cookies.set('userType', 'kis');

  useEffect(() => {
    const timer = setTimeout(() => {
      navigation('/signin');
    }, 1000);

    // 클린업 함수
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div id="main_loading_container" className="kis">
      <img className="logo" src={logo} alt="로고" />
    </div>
  );
};

export default MainLoadingForKis;
